/****************************************************************************
 **
 ** Copyright (C) 2021 The Qt Company Ltd.
 ** Contact: https://www.qt.io/licensing/
 **
 ** This file is part of Qt Bridge Plugin.
 **
 ** Commercial License Usage
 ** Licensees holding valid commercial Qt licenses may use this file in
 ** accordance with the commercial license agreement provided with the
 ** Software or, alternatively, in accordance with the terms contained in
 ** a written agreement between you and The Qt Company. For licensing terms
 ** and conditions see https://www.qt.io/terms-conditions. For further
 ** information use the contact form at https://www.qt.io/contact-us.
 **
 ****************************************************************************/

export const PanelHeight = 710;
export const PanelWidth = 400;

// Progress shares
export const PSCompose = { start: 0, end: 10 };
export const PSOverride = { start: 10, end: 20 };
export const PSAssets = { start: 20, end: 80 };
export const PSMetadata = { start: 80, end: 90 };

export const ExportInvalidType = "None";

export const ExportType = Object.freeze({
    AsComponent: "component",
    AsChild: "child",
    MergedToParent: "merged",
    SkipExport: "skip"
});

export const SketchLayerType = Object.freeze({
    Unknown: "Unknown",
    Artboard: "Artboard",
    Group: "Group",
    Text: "Text",
    Hotspot: "HotSpot",
    SymbolMaster: "SymbolMaster",
    SymbolInstance: "SymbolInstance"
});

export const ValidExportFormats = Object.freeze({
    Png: "png",
    Jpg: "jpg",
    Svg: "svg"
});

export const ValidExportScale = Object.freeze({
    Normal: 1,
    Double: 2
});

export const ConstExportOptions = {
    "use-id-for-name": true,
    overwriting: true
};

export const LogLevels = Object.freeze({
    Info: 0,
    Warning: 1,
    Error: 2
});

export const Actions = Object.freeze({
    Undo: "MSUndoAction",
    Redo: "MSRedoAction"
});
